var _defs, _g, _rect, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColumnFormatPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 177,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h120v36.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    fill: "#fff",
    d: "M0 0h120v35.01H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 176.05,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M0 0h60v36.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M11.16 23.13a2.3 2.3 0 0 1-1.86-.85c-.46-.56-.7-1.4-.7-2.5 0-1.11.24-1.95.71-2.52.48-.57 1.1-.86 1.88-.86a2.46 2.46 0 0 1 1.5.49c.18.15.33.31.45.5h.07a14.2 14.2 0 0 1-.1-1.17V13.9h1.38v9.12H13.4l-.25-.89h-.06a2.07 2.07 0 0 1-1.08.87c-.24.1-.52.14-.86.14Zm.4-1.12c.58 0 1-.17 1.24-.51.24-.34.37-.85.37-1.53v-.18c0-.73-.11-1.29-.35-1.67-.23-.4-.66-.59-1.28-.59-.5 0-.88.2-1.14.6-.26.4-.38.96-.38 1.67 0 .72.12 1.27.38 1.65.26.37.65.56 1.15.56ZM19 16.4c.82 0 1.44.18 1.86.55.42.36.63.93.63 1.7V23h-.97l-.27-.92h-.04c-.19.23-.38.43-.57.58-.2.15-.43.27-.68.34a3.2 3.2 0 0 1-1.97-.1c-.3-.14-.55-.36-.72-.65a2.1 2.1 0 0 1-.27-1.11c0-.67.25-1.17.75-1.5.5-.35 1.25-.53 2.26-.57l1.12-.04v-.34c0-.45-.1-.77-.31-.96-.2-.19-.5-.28-.88-.28-.32 0-.64.04-.94.14-.3.09-.6.2-.9.34l-.44-.97A5 5 0 0 1 19 16.4Zm1.13 3.51-.84.03c-.69.02-1.17.14-1.45.35-.27.21-.41.5-.41.87 0 .32.1.55.28.7.2.15.45.22.76.22.48 0 .87-.14 1.18-.4.32-.28.48-.68.48-1.2v-.57Zm5.7 2.1a3.04 3.04 0 0 0 1.02-.17v1.05a3.97 3.97 0 0 1-1.35.24c-.37 0-.7-.06-.99-.18a1.5 1.5 0 0 1-.7-.64c-.17-.3-.25-.72-.25-1.25v-3.49h-.89v-.61l.95-.49.45-1.39h.87v1.44h1.86v1.05h-1.86v3.47c0 .33.08.57.25.73a.9.9 0 0 0 .65.24Zm4.88-5.61c.82 0 1.44.18 1.86.55.42.36.63.93.63 1.7V23h-.98l-.26-.92h-.05c-.18.23-.37.43-.57.58-.2.15-.42.27-.68.34a3.2 3.2 0 0 1-1.96-.1 1.7 1.7 0 0 1-.73-.65 2.2 2.2 0 0 1-.26-1.11c0-.67.25-1.17.75-1.5.5-.35 1.25-.53 2.26-.57l1.12-.04v-.34c0-.45-.1-.77-.31-.96-.21-.19-.5-.28-.88-.28-.33 0-.64.04-.95.14-.3.09-.6.2-.89.34l-.44-.97a5 5 0 0 1 2.34-.57Zm1.13 3.51-.84.03c-.69.02-1.17.14-1.45.35-.28.21-.42.5-.42.87 0 .32.1.55.3.7.18.15.44.22.75.22.47 0 .87-.14 1.18-.4.32-.28.48-.68.48-1.2v-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M60 0h60v36.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M76.31 16.4c.73 0 1.28.19 1.65.56.37.38.55.98.55 1.8v4.25h-1.38v-4c0-.49-.1-.86-.28-1.11-.2-.25-.48-.37-.88-.37-.54 0-.94.17-1.18.52s-.36.86-.36 1.52v3.44h-1.37v-4c0-.32-.05-.6-.13-.82a.96.96 0 0 0-.38-.5 1.16 1.16 0 0 0-.65-.16c-.38 0-.69.08-.91.25-.22.18-.38.43-.48.76-.1.34-.15.75-.15 1.23v3.24h-1.38v-6.49h1.08l.19.88h.08c.13-.23.3-.42.49-.56.2-.15.42-.26.66-.33.24-.07.5-.11.76-.11.48 0 .89.09 1.22.26.33.17.58.42.75.77h.1c.2-.35.49-.61.85-.78.36-.17.75-.25 1.15-.25Zm9.87 3.35a4.5 4.5 0 0 1-.22 1.44 2.71 2.71 0 0 1-1.59 1.72 3.61 3.61 0 0 1-2.5-.01 2.8 2.8 0 0 1-1.6-1.71c-.14-.42-.22-.9-.22-1.44 0-.71.13-1.32.37-1.81.25-.5.6-.89 1.07-1.15.46-.26 1-.39 1.64-.39.6 0 1.13.13 1.59.4.45.25.81.64 1.07 1.14.26.5.39 1.1.39 1.81Zm-4.7 0c0 .47.05.88.16 1.21.12.34.3.6.54.78.24.17.55.26.94.26.38 0 .7-.09.93-.26.25-.18.42-.44.54-.78.11-.33.17-.74.17-1.2 0-.48-.06-.88-.17-1.2-.12-.34-.3-.6-.54-.77a1.57 1.57 0 0 0-.94-.26c-.57 0-.98.2-1.25.58a2.9 2.9 0 0 0-.39 1.64Zm8.9 3.38c-.62 0-1.15-.12-1.6-.36a2.4 2.4 0 0 1-1.04-1.1 4.24 4.24 0 0 1-.36-1.87c0-.79.13-1.43.4-1.93.26-.5.63-.87 1.1-1.11a4.33 4.33 0 0 1 3.47.04l-.4 1.1c-.25-.1-.5-.19-.74-.25a2.8 2.8 0 0 0-.72-.1c-.38 0-.7.08-.95.25a1.5 1.5 0 0 0-.56.75c-.12.33-.19.74-.19 1.24 0 .47.07.88.2 1.2.12.33.3.57.55.74.25.17.55.25.9.25a3.27 3.27 0 0 0 1.76-.46v1.2c-.25.13-.51.24-.8.3-.27.07-.62.1-1.03.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 36.01h120v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 36.01h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4963.99v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 36.01h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4963.99v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 71.02h120v35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 71.02h60v35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4928.98v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 71.02h60v35H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4928.98v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 106.03h120v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 106.03h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4893.97v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 106.03h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4893.97v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 141.04h120v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 141.04h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4858.96v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 141.04h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4858.96v10000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 175.05,
    x: 0.5,
    y: 0.5,
    stroke: "#DBDFEC",
    rx: 3.5
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 176.05,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 36.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 71.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 106.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 141.04)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 120,
    height: 36.01,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_3964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 120,
    height: 35.01,
    x: 0,
    y: 36.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_3964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 120,
    height: 35.01,
    x: 0,
    y: 71.02,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_3964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 120,
    height: 35.01,
    x: 0,
    y: 106.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_3964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 120,
    height: 35.01,
    x: 0,
    y: 141.04,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_3964"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnFormatPreview);
export default __webpack_public_path__ + "static/media/column-format-preview.9d58e1131fb9fd021790e23e6f144916.svg";
export { ForwardRef as ReactComponent };